import React, { useState, useEffect, useCallback } from "react";
import { Button, Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import { Action, PerPage, Role } from "../../constants/Common";
import Loader from "../../Components/Common/Loader";
import NodataFound from "../../Components/Common/NoDataFound";
import userImage from "../../assets/images/icons/ticket.png";
import { Helmet } from "react-helmet";
import { filter } from "lodash/collection";
import { get } from "lodash/object";
import { getIconPath } from "../../helpers/file_helper";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { ActionModule, ActivityModule, Modules } from "../../constants/Module";
import { useSelector } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import { useLocation, useNavigate } from "react-router-dom";
import { withTranslation, useTranslation } from "react-i18next";
import Search from "../../Components/casp/common/Search";
import { ApprovalStatuses } from "../../constants/Status";
import { Autocomplete, TextField, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getAllProject } from "../../api/casp/project";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import { getAllApprovalList, updateApprovalStatus } from "../../api/casp/approval";
import moment from "moment";
import { toast } from "react-toastify";
import CommentModal from "../../Components/casp/common/CommentModal";
import ApprovalUserHistory from "../../Components/Actions/ApprovalUserHistory";
import { ucFirst } from "../../helpers/string_helper";
// import { makeStyles } from "@material-ui/core";
import SubmitLegalDocument from "../../Components/ProjectSubmission/submitLegalDocument";
import SubmitDeliverable from "../../Components/ProjectSubmission/submitDeliverable";
import { getProjectDeliverableDetails } from "../../api/casp/projectDeliverable";
import SubmitLegalDocumentComment from "../../Components/ProjectSubmission/submitLegalDocumentComment";
import SubmitSecondDeliverableComment from "../../Components/ProjectSubmission/SubmitSecondDeliverableComment";
import SubmitSecondDeliverable from "../../Components/ProjectSubmission/submitSecondDeliverable";
import { getAllDeliverableList } from "../../api/casp/deliverable";
import { getAllPortfolios } from "../../api/casp/portfolio";
import SubmitOtherDeliverableComment from "../../Components/ProjectSubmission/submitOtherDeliverableComment";

const useStyles = makeStyles({
  wrap_data_grid: {
    "& .MuiDataGrid-cell": {
      padding: "0 !important",
    },
  },
});

const ActionList = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [aprrovalList, setAprrovalList] = useState([]);
  const [selectedApproval, setSelectedApproval] = useState();
  const [page, setPage] = useState(0);
  const [action, setAction] = useState(null);
  const [deliverableAction, setDeliverableAction] = useState(null);
  const [moduleName, setModuleName] = useState("");
  const [moduleDetail, setModuleDetail] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [moduleId, setModuleId] = useState();
  const [moduleType, setModuleType] = useState();
  const [projectId, setProjectId] = useState();
  // const [status, setStatus] = useState();
  const [approvalId, setApprovalId] = useState();
  const [search, setSearch] = useState("");
  const [searchedTerm, setSearchedTerm] = useState(null);
  // const [projectDetails, setProjectDetails] = useState();
  const [selectedDeliverable, setSelectedDeliverable] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filterData, setFilterData] = useState({
    filterFields: [],
    filterInputs: [],
  });
  const loggedInUser = useSelector((state) => state.Profile.user);
  const [project, setProject] = useState();
  const [module, setModule] = useState(null);
  const [isOpenApprovalDrawer, setIsOpenDrawer] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const location = useLocation();
  const highlightRow = location?.state?.moduleRelation
    ? JSON.parse(location?.state?.moduleRelation)
    : "";

  const [rowId, setRowId] = useState()
  const [actionType, setActionType] = useState()
  const [projectIdForApproval, setProjectIdForApproval] = useState()
  const [moduleIdforApproval, setModuleIdForApproval] = useState()
  const [isLoadingDeliverable, setIsLoadingDeliverable] = useState(false)
  const [deliverableList, setDeliverableList] = useState([])
  const [portfolio, setPortfolio] = useState()
  const [comment, setComment] = useState()
  const [deliverbleStatus,setDeliverableStatus] = useState('')

  const truncateText = (text) => text?.length > 30 ? `${text.slice(0, 30)}...` : text;

  const columnData = [
    {
      field: "index",
      headerName: "#",
      width: 85,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor:
              highlightRow?.id === params.row?.id ? "#cce6ff" : "",
            padding: "0 10px",
          }}
        >
          <div className="MuiDataGrid-cellContent">{params.row?.indexNo}</div>
        </div>
      ),
    },
    // {
    //   field: "portfolio",
    //   headerName: props.t("Incubator"),
    //   width: 300,
    //   filterable: false,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <div
    //       style={{
    //         display: "flex",
    //         alignItems: "center",
    //         width: "100%",
    //         height: "100%",
    //         backgroundColor:
    //           highlightRow?.id === params.row?.id ? "#cce6ff" : "",
    //         padding: "0 10px",
    //       }}
    //     >
    //       <div className="MuiDataGrid-cellContent">{params.row?.portfolio}</div>
    //     </div>
    //   ),
    // },
    // {
    //   field: "projectUniqueId",
    //   headerName: props.t("Startup ID"),
    //   width: 200,
    //   filterable: false,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <div
    //       style={{
    //         display: "flex",
    //         alignItems: "center",
    //         width: "100%",
    //         height: "100%",
    //         backgroundColor:
    //           highlightRow?.id === params.row?.id ? "#cce6ff" : "",
    //         padding: "0 10px",
    //       }}
    //     >
    //       <div className="MuiDataGrid-cellContent">
    //         {params.row?.projectUniqueId}
    //       </div>
    //     </div>
    //   ),
    // },
    {
      field: "projectName",
      headerName: props.t("Startup Name"),
      width: 300,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor:
              highlightRow?.id === params.row?.id ? "#cce6ff" : "",
            padding: "0 10px",
          }}
        >
          <div className="MuiDataGrid-cellContent">
            {params.row?.projectName}
          </div>
        </div>
      ),
    },
    {
      field: "projectManager",
      headerName: props.t("Founder"),
      width: 300,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor:
              highlightRow?.id === params.row?.id ? "#cce6ff" : "",
            padding: "0 10px",
          }}
        >
          <div className="MuiDataGrid-cellContent">
            {params.row?.projectManager}
          </div>
        </div>
      ),
    },
    {
      field: "actionType",
      headerName: props.t("Action Type"),
      width: 350,
      filterable: false,
      sortable: false,
      // renderCell: (params) => (
      //   <div
      //     style={{
      //       display: "flex",
      //       alignItems: "center",
      //       width: "100%",
      //       height: "100%",
      //       backgroundColor:
      //         highlightRow?.id === params.row?.id ? "#cce6ff" : "",
      //       padding: "0 10px",
      //     }}
      //   >
      //     <div className="MuiDataGrid-cellContent">
      //       {params.row?.actionType === "Projectdeliverable" ? t("Deliverable") : (params.row?.actionType === "Project" ? t("Startup") : "")}
      //     </div>
      //   </div>
      // ),
      renderCell: (params) => {
        const isDeliverable = params.row?.actionType === "Projectdeliverable";
        const isStartup =
          params.row?.actionType === "Startup" ||
          params.row?.actionType === "Project";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              backgroundColor:
                highlightRow?.id === params.row?.id ? "#cce6ff" : "",
              padding: "0 10px",
            }}
          >
            {isDeliverable ? (
              <>
              <button
                onClick={async (e) => {
                  e.preventDefault()
                  setDeliverableStatus(params.row.status)
                  const projectId = params.row.approvalUsers[0].project.id;
                  await fetchDeliverableDetails(params.row.moduleId, projectId, Action.VIEW, {}, params.row.portfolioId);
                  setRowId(params.row.id)
                  setProjectIdForApproval(projectId)
                  setModuleIdForApproval(params.row.moduleId)
                  setActionType(params.row.actionType)
                  // setDeliverableStatus(params.row.status)

                  await fetchDeliverableDetails(params.row.moduleId, projectId, Action.APPROVE_REJECT_SHOW, {}, params.row.portfolioId);
                }}
                style={{
                  cursor: "pointer",
                  color: "blue",
                  textDecoration: "underline",
                  background: "none",
                  border: "none",
                  padding: 0,
                  font: "inherit",
                }}
                className="MuiDataGrid-cellContent"
              >
                {props.t("Deliverable")}
                </button>-
                <Tooltip title={params.row?.moduleDetails?.deliverable?.name}>
                  {truncateText(params.row?.moduleDetails?.deliverable?.name)}
                </Tooltip>
              </>
            ) : isStartup ? (
              <button
                style={{
                  cursor: "pointer",
                  color: "red",
                  textDecoration: "underline",
                  border: "none",
                  background: "none",
                  padding: 0,
                  font: "inherit",
                }}
                onClick={() =>
                  navigate(
                    `/project/${params.row.approvalUsers[0].project.id}/details`
                  )
                }
                className="MuiDataGrid-cellContent"
              >
                {props.t("Startup")}
              </button>
            ) : (
              <div className="MuiDataGrid-cellContent">
                {params.row?.actionType}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "receivedDate",
      headerName: props.t("Received Date"),
      width: 300,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor:
              highlightRow?.id === params.row?.id ? "#cce6ff" : "",
            padding: "0 10px",
          }}
        >
          <div className="MuiDataGrid-cellContent">
            {params.row?.receivedDate}
          </div>
        </div>
      ),
    },
    {
      field: "action",
      headerName: props.t("Actions"),
      sortable: false,
      width: 300,
      filterable: false,
      hideable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              backgroundColor:
                highlightRow?.id === params.row?.id ? "#cce6ff" : "",
              padding: "0 10px",
              width: "100%",
              height: "100%",
            }}
          >
            <div
              className="proSubmissionActions"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: "7px",
                paddingTop: "6px",
              }}
            >
              <button
                style={{
                  cursor: "pointer",
                  border: "none",
                }}
                onClick={() => {
                  setSelectedApproval(params.row.approvalUsers);
                  setModuleName(params.row.actionType);
                  setModuleDetail(params.row.moduleDetails);
                  if (params.row?.actionType === "Deliverable") {
                    setAction("view");
                  } else {
                    setAction("approval");
                  }
                  setIsOpenDrawer(true);
                }}
              >
                <RemoveRedEyeOutlinedIcon />
              </button>
              {params.row.actionStatus === ApprovalStatuses.PENDING ? (
                // && params.row?.currentApprovalUser?.userId === loggedInUser.id ? (
                <>
                  <Button
                    disableElevation
                    variant="contained"
                    className="approveBtn"
                    style={{
                      backgroundColor: "#90EE90",
                      color: "black",
                      border: "none",
                      textTransform: "none",
                    }}
                    onClick={(e) => {
                      e.preventDefault()
                      if (params.row.actionType === "Projectdeliverable") {
                        const projectId = params.row.approvalUsers[0].project.id;
                        setRowId(params.row.id)
                        setActionType(params.row.actionType.toLowerCase() === 'startup' ? Modules.PROJECT : params.row.actionType)
                        setProjectIdForApproval(params.row.approvalUsers[0].project.id)
                        setModuleIdForApproval(params.row.moduleId)
                        fetchDeliverableDetails(params.row.moduleId, projectId, Action.APPROVE, {
                          moduleId: params.row.moduleId,
                          actionType: "projectDeliverable",
                          projectId,
                          approvalId: params.row.id
                        }, params.row.portfolioId);
                      } else {
                        handleStatusChange(
                          params.row.moduleId,
                          params.row.actionType.toLowerCase() === 'startup' ? Modules.PROJECT : params.row.actionType,
                          params.row.approvalUsers[0].project.id,
                          ApprovalStatuses.APPROVED,
                          params.row.id
                        )
                      }
                    }
                    }
                  >
                    <DoneIcon className="me-1" />
                    {props.t("Approve")}
                  </Button>
                  <Button
                    disableElevation
                    variant="contained"
                    color="error"
                    className="rejectBtn"
                    onClick={(e) => {
                      e.preventDefault()
                      if (params.row.actionType === "Projectdeliverable") {
                        const projectId = params.row.approvalUsers[0].project.id;
                        setActionType(params.row.actionType)
                        fetchDeliverableDetails(params.row.moduleId, projectId, Action.SUBMIT, {
                          moduleId: params.row.moduleId,
                          actionType: "projectDeliverable",
                          reason: params.row.reason ?? "",
                          projectId,
                          approvalId: params.row.id
                        }, params.row.portfolioId);
                      } else {
                        handleReject(
                          params.row.moduleId,
                          params.row.actionType.toLowerCase() === 'startup' ? Modules.PROJECT : params.row.actionType,
                          params.row.approvalUsers[0].project.id,
                          params.row.id
                        )
                      }
                    }}
                    style={{
                      marginRight: "10px",
                      backgroundColor: "#FFC0CB",
                      color: "black",
                      textTransform: "none",
                    }}
                  >
                    <ClearIcon className="me-1" />
                    {props.t("Reject")}
                  </Button>
                </>
              ) : (
                <span className="my-1">{t(params.row.actionStatus)}</span>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "reason",
      headerName: props.t("Reason"),
      width: 300,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%",
            backgroundColor:
              highlightRow?.id === params.row?.id ? "#cce6ff" : "",
            padding: "0 10px",
          }}
        >
          <div className="MuiDataGrid-cellContent">{params.row?.reason}</div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    fetchProjectList()
  }, []);

  const handleCloseDrawer = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setIsOpenDrawer(false);
    setSelectedRow(null);
    setAction(null);
    setDeliverableStatus(null);
  };

  const fetchDeliverableDetails = async (deliverableId, projectId, action, row, portfolioId) => {
    try {
      const response = await getProjectDeliverableDetails(deliverableId, {
        projectId: projectId,
        portfolioId: portfolioId
      });
      if (
        action === Action.SUBMIT
          ? (
            (response?.data?.data?.deliverable?.deliverableOrder === 1 ||
              response?.data?.data?.deliverable?.deliverableOrder === 2)
            && row
          )
          : (action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW)
      )
    {
        setModuleName("Deliverable");
        setSelectedDeliverable({ ...response.data.data, ...row });
        setDeliverableAction(action);
        setDrawerOpen(true);
      } else {
        setSelectedDeliverable({ ...response.data.data, ...row });
        handleReject(
          row.moduleId,
          "Projectdeliverable",
          row.projectId,
          row.approvalId
        )
      }
    } catch (error) {
      console.error("Error fetching deliverable details:", error);
      toast.error("Failed to fetch deliverable details");
    }
  };


  const handleCloseDeliverableDrawer = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setDrawerOpen(false);
    setSelectedDeliverable();
    setDeliverableAction()
  };

  const handleCloseModal = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setOpenModal(false);
    setSelectedApproval();
    setSelectedRow(null)
    setAction();
    setModuleId();
    setModuleType();
    setProjectId();
    setApprovalId();
    setActionType();
    setModuleIdForApproval();
    setProjectIdForApproval();
    setRowId()
  };

  const fetchActionList = useCallback(async (queryParams) => {
    try {
      setAprrovalList([]);
      setIsLoading(true);
      let params
      if (queryParams) {
        params = {
          ...queryParams,
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      } else {
        params = {
          ...filterData,
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      }
      const res = await getAllApprovalList(params);
      let level = (params?.page - 1) * params?.perPage;

      // Fix: Access the correct data structure from response
      const approvalData = res.data.data.data;
      // let resultData = approvalData.map((data, index) => {
      //   const isProjectModule = data.module === 'project';
      //   const firstApprovalUser = data.approvalUsers?.[0];

      //   // Get project details based on module type
      //   const projectDetails = isProjectModule
      //     ? data.moduleDetails
      //     : firstApprovalUser?.project;

      //   const portfolioName = isProjectModule
      //     ? null
      //     : firstApprovalUser?.project?.portfolioProjects?.[0]?.portfolio?.name;

      //   const projectManagerName = isProjectModule
      //     ? data.moduleDetails?.projectAdmin?.name
      //     : firstApprovalUser?.project?.projectAdmin?.name;

      //   return {
      //     id: data.id,
      //     indexNo: ++level,
      //     portfolio: portfolioName || "-",
      //     projectUniqueId: projectDetails?.uniqueProjectId || "-",
      //     projectName: projectDetails?.name || "-",
      //     status: data.status,
      //     reason: data.comments ? data.comments : "-",
      //     approvalUsers: data.approvalUsers || [],
      //     projectManager: projectManagerName || "-",
      //     currentApprovalUser: data.currentApprovalUser,
      //     moduleId: data.moduleId,
      //     actionType: data.module === ActionModule.CHANGE_REQUEST
      //       ? ucFirst("change request")
      //       : ucFirst(data.module),
      //     moduleDetails: data.moduleDetails,
      //     receivedDate: moment(data.createdAt).format("Do MMMM, YYYY"),
      //   };
      // });
      let resultData = approvalData?.flatMap((data) =>
        data.approvalUsers
          .filter((user) => user.userId === loggedInUser.id)
          .map((user) => {
            return {
              id: data.id,
              indexNo: ++level,
              portfolio: user?.project?.portfolioProjects[0]?.portfolio?.name,
              projectUniqueId: user.project.uniqueProjectId,
              portfolioId: user.project.portfolioId,
              projectName: user?.project?.name,
              status: user.status,
              actionStatus: data?.status,
              reason: data.comments ? data.comments : '-',
              approvalUsers: data.approvalUsers,
              projectManager: user?.project?.projectAdmin?.name,
              currentApprovalUser: data.currentApprovalUser ? data.currentApprovalUser : null,
              moduleId: data.moduleId,
              actionType: data.module === ActionModule.PROJECT ? ucFirst('startup') : ucFirst(data.module),
              moduleDetails: data.moduleDetails,
              receivedDate: moment(data.createdAt).format("Do MMMM, YYYY")
            };
          })
      );
      setAprrovalList(resultData);
      // Fix: Access meta information correctly
      setRowCount(res.data.data.meta.total);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(error.message);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser.id, rowsPerPage, search]);

  useEffect(() => {
    fetchActionList({
      page: page + 1,
      perPage: rowsPerPage,
      ...filterData,
    });
  }, [fetchActionList, page, rowsPerPage, filterData, triggerData]);

  const fetchProjectList = async () => {
    try {
      setIsLoading(true);
      // let params = {
      //   filterFields: ["status"],
      //   filterInputs: [ProjectStatuses.ONGOING]
      // }
      const res = (await getAllProject()).data.data;
      const resultData = res.data.map((res) => {
        return res.name;
      });
      setProjectList(resultData);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleStatusChange = async (
    moduleId,
    moduleName,
    projectId,
    status,
    approvalId,
    comments = null
  ) => {
    try {
      setIsLoading(true);
      let params = {
        moduleId: moduleId,
        module: moduleName === "Projectdeliverable" ? "projectDeliverable" : moduleName?.toLowerCase(),
        projectId: projectId,
        status: status,
      };
      if (comments) {
        params.comments = comments;
      }

      const res = await updateApprovalStatus(approvalId, params);
      if (res?.statusCode === 200 && status === ApprovalStatuses.APPROVED) {
        toast.success(res.data.message);
        handleCloseDeliverableDrawer()
        // handleCloseModal()
      } else if (
        res?.statusCode === 200 &&
        status === ApprovalStatuses.REJECTED
      ) {
        toast.error(res.data.message);
        handleCloseDeliverableDrawer()
      }
      setTriggerData(+new Date());
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleReject = async (moduleId, moduleName, projectId, approvalId) => {
    setOpenModal(true);
    setModuleId(moduleId);
    setModuleType(moduleName);
    setProjectId(projectId);
    setApprovalId(approvalId);
  };

  const handletrigger = async (status, comment, moduleIdReject, moduleTypeReject, projectIdReject, approvalIdReject) => {
    if (moduleIdReject && moduleTypeReject && projectIdReject && approvalIdReject) {
      await handleStatusChange(
        moduleIdReject,
        moduleTypeReject,
        projectIdReject,
        status,
        approvalIdReject,
        comment
      );
    } else {
      await handleStatusChange(
        moduleId,
        moduleType,
        projectId,
        status,
        approvalId,
        comment
      );
    }
      handleCloseModal();
    };

    const handleModuleChange = async (_, newSelectedOption) => {
      // if (item == null) {
      setModule(newSelectedOption);

      if (newSelectedOption == null) {
        setFilterData((prevFilter) => {
          const index = prevFilter.filterFields.indexOf("module");
          if (index === -1) return prevFilter;

          const updatedFilterFields = [...prevFilter.filterFields];
          const updatedFilterInputs = [...prevFilter.filterInputs];
          updatedFilterFields.splice(index, 1);
          updatedFilterInputs.splice(index, 1);

          return {
            filterFields: updatedFilterFields,
            filterInputs: updatedFilterInputs,
          };
        });
      } else {
        // if (item === "Startup") {
        //   item = ActionModule.PROJECT;
        // } else {
        //   item = item.toLowerCase();
        // }
        // const moduleValue = item === "deliverable" ? "projectDeliverable" : item;
        let moduleValue = newSelectedOption.value
        if (moduleValue === ActionModule.DELIVERABLE) {
          moduleValue = 'projectDeliverable'
        }

        setFilterData((prevFilter) => {
          const index = prevFilter.filterFields.indexOf("module");
          if (index !== -1) {
            const updatedFilterInputs = [...prevFilter.filterInputs];
            updatedFilterInputs[index] = moduleValue;
            return {
              ...prevFilter,
              filterInputs: updatedFilterInputs,
            };
          } else {
            return {
              filterFields: [...prevFilter.filterFields, "module"],
              filterInputs: [...prevFilter.filterInputs, moduleValue],
            };
          }
        });
      }

      setTriggerData(+new Date());
    };

    const moduleOptions = React.useMemo(() => {
      const isEpmoOfficer = loggedInUser?.role?.name === Role.EPMO_OFFICER

      const staticOptions = Object.values(ActionModule)
        .filter(item => item !== ActionModule.CHANGE_REQUEST &&
          item !== ActionModule.MILESTONE &&
          item !== ActionModule.DELIVERABLE &&
          (isEpmoOfficer || item !== ActivityModule.PROJECT)
        )
        .map(value => ({
          value,
          label: value === ActivityModule.PROJECT ? t(ucFirst("startup")) : t(ucFirst(value))
        }));

      const filteredDeliverables = isEpmoOfficer
        ? deliverableList
        : deliverableList.filter(d => d.order !== 1);

      return [...staticOptions, ...filteredDeliverables];
    }, [t, deliverableList, loggedInUser]);


    const deliverableRefresh = async () => {
      setTriggerData(+new Date());
    };

    // Global Search
    const globalSearch = async (params) => {
      setSearch(params.search);
      // if (params?.page) {
      //   setPage(params.page);
      // }
      await fetchActionList(params);
    };

    const getRowId = (row) => row?.id;
    const paginationModelMethod = async (data) => {
      setPage(data.page);
      setRowsPerPage(data.pageSize);
      setTriggerData(+new Date());
    };

    const fetchDeliverableList = async () => {
      try {
        setIsLoadingDeliverable(true);

        const res = await getAllDeliverableList();

        // Sort deliverables by createdAt (earliest first)
        const sortedData = res?.data?.data?.data?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

        const resultData = await Promise.all(sortedData.map(async (res, idx) => {

          return {
            value: res.id,
            label: res.name,
            order: res.deliverableOrder
          };
        }));
        setDeliverableList(resultData);
        setIsLoadingDeliverable(false);
      } catch (error) {
        console.error("Failed to fetch deliverable list:", error);
        setIsLoadingDeliverable(false);
      }
    }

    useEffect(() => {
      fetchDeliverableList()
    }, [])


    return (
      <div className="page-content position-relative">
        <Helmet
          onChangeClientState={(newState) => {
            try {
              // Check if we added any new link[rel="icon"] elements.
              const newFaviconElems = filter(get(newState, "linkTags", []), {
                rel: "icon",
              });
              if (!newFaviconElems.length) {
                return;
              }
              // Get the href of the last link element we just added, which
              // we assume is the most recently-added favicon.
              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href;
              // Remove all react-helmet link elements with rel="icon" that
              // do not have the href of our recently-added favicon.
              // If no other favicon elements exist, we don't have to do
              // anything.
              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              );
              if (existingFavicons.length) {
                existingFavicons.forEach((e) => e.parentNode.removeChild(e));
              }
              // Remove and re-add the latest link element to make sure
              // the browser uses it.
              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              );
              const iconToShow = <ManageAccountsIcon />;
              //<i className={'ri-git-pull-request-line'}></i>
              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true);
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(
                    iconToShow
                  )}</svg>`
                )}`;
                const parentElem = newFaviconElem.parentNode;
                parentElem.removeChild(newFaviconElem);
                parentElem.appendChild(newFavElement);
              }
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <title>{props.t("All Actions")}</title>
        </Helmet>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb title={props.t("All Actions")} />
            </div>

            <div className="d-flex justify-content-end ongoingSearchField">
              {/* {
              loggedInUser?.role?.name===Role.EPMO_OFFICER && ( */}
              <div className="me-2">
                <Autocomplete
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={module}
                  size="small"
                  sx={{ width: "210px" }}
                  options={moduleOptions}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  onChange={handleModuleChange}
                  noOptionsText={t("No options")}
                  loadingText={t("Loading...")}
                  renderInput={(params) => (
                    <TextField {...params} label={props.t("Module Name")} />
                  )}
                />
              </div>
              {/* )} */}

              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Cohort")}
                  sx={{
                    width: 200,
                  }}
                  searchEnabled={false}
                  listCall={getAllPortfolios}
                  disableClearable={!portfolio}
                  defaultValue={portfolio}
                  apiParams={{
                    order: "updatedAt",
                    direction: "desc",
                    ...(![
                      Role.PROJECT_MANAGER,
                      Role.EPMO_MANAGER,
                      Role.ROOT_ADMIN,
                      Role.VICE_PRESIDENT,
                      Role.PRESIDENT,
                      Role.PROGRAM_MANAGER,
                      Role.EPMO_OFFICER,
                      Role.MENTOR
                    ].includes(loggedInUser?.role?.name) && {
                      filterFields: "portfolioUser",
                      filterInputs: loggedInUser.id,
                    }),
                  }}
                  emitItem={(newValue) => {
                    setPortfolio(newValue);
                    setPage(0);

                    setFilterData((prevFilter) => {
                      const updatedFilterFields = [...prevFilter.filterFields];
                      const updatedFilterInputs = [...prevFilter.filterInputs];
                      const index = updatedFilterFields.indexOf("portfolio");

                      if (newValue) {
                        if (index !== -1) {
                          updatedFilterInputs[index] = String(newValue.id);
                        } else {
                          updatedFilterFields.push("portfolio");
                          updatedFilterInputs.push(String(newValue.id));
                        }
                      } else {
                        if (index !== -1) {
                          updatedFilterFields.splice(index, 1);
                          updatedFilterInputs.splice(index, 1);
                        }
                      }

                      return {
                        filterFields: updatedFilterFields,
                        filterInputs: updatedFilterInputs,
                      };
                    });

                    setTriggerData(+new Date());
                  }}


                />
              </div>
              <div className="me-2">
                <SearchDropDownListPaginationComponent
                  label={props.t("Startup Name")}
                  searchEnabled={false}
                  disableClearable={!project}
                  listCall={getAllProject}
                  defaultValue={project}
                  size="small"
                  sx={{ width: "200px" }}
                  // emitItem={(newValue) => {
                  //   setProject(newValue);
                  //   if (newValue) {
                  //     setFilterData({
                  //       filterFields: ["approvalUsers"],
                  //       filterInputs: [newValue.name],
                  //     });
                  //   } else {
                  //     setFilterData({
                  //       filterFields: [],
                  //       filterInputs: [],
                  //     });
                  //   }
                  //   setTriggerData(+new Date());
                  // }}
                  emitItem={(newValue) => {
                    setProject(newValue);

                    setFilterData((prevFilter) => {
                      const updatedFilterFields = [...prevFilter.filterFields];
                      const updatedFilterInputs = [...prevFilter.filterInputs];
                      const index = updatedFilterFields.indexOf("approvalUsers");

                      if (newValue) {
                        if (index !== -1) {
                          updatedFilterInputs[index] = newValue.name;
                        } else {
                          updatedFilterFields.push("approvalUsers");
                          updatedFilterInputs.push(newValue.name);
                        }
                      } else {
                        if (index !== -1) {
                          updatedFilterFields.splice(index, 1);
                          updatedFilterInputs.splice(index, 1);
                        }
                      }

                      return {
                        filterFields: updatedFilterFields,
                        filterInputs: updatedFilterInputs,
                      };
                    });

                    setTriggerData(+new Date());
                  }}

                  apiParams={
                    searchedTerm && searchedTerm !== "undefined"
                      ? {
                        filterFields: ["name"],
                        filterInputs: [searchedTerm],
                      }
                      : {}
                  }
                  handleInputChange={(data) => {
                    if (data.includes("|")) {
                      let splitText = data.split("|");
                      setSearchedTerm(splitText[1]);
                    } else {
                      setSearchedTerm(data);
                    }
                  }}
                />
              </div>
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    ...(props?.status
                      ? {
                        filterFields: ["status"],
                        filterInputs: [props.status],
                      }
                      : {}),
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
            </div>
          </div>
          <div className="accordionTable my-4" style={{ width: "100%" }}>

            {isLoading && aprrovalList.length === 0 ? (
              <Loader />
            ) : aprrovalList.length === 0 ? (
              <NodataFound text={props.t("No actions to show")} icon={userImage} />
            ) : (
              <div className={classes.wrap_data_grid}>
                <DataGrid
                  key={refreshKey}
                  rows={aprrovalList}
                  columns={columnData}
                  disableRowSelectionOnClick
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: rowsPerPage },
                    },
                  }}
                  pagination
                  paginationModel={{ page: page, pageSize: rowsPerPage }}
                  paginationMode="server"
                  onPaginationModelChange={paginationModelMethod}
                  rowCount={rowCount}
                  pageSizeOptions={PerPage}
                  getRowId={getRowId}
                  loading={isLoading}
                  // onRowSelectionModelChange={(e) => setIsSendMsg({ data: e, status: false })}
                  // checkboxSelection={loggedInUser?.role?.name === Role.EPMO_OFFICER}
                  localeText={{
                    MuiTablePagination: {
                      labelRowsPerPage: t("Actions per page:"), // Or your desired custom text
                    },
                  }}
                />
              </div>
            )}


            {/* {aprrovalList.length > 0 && (
            <div className={classes.wrap_data_grid}>
              <DataGrid
                key={refreshKey}
                rows={aprrovalList}
                columns={columnData}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={rowCount}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
                // onRowSelectionModelChange={(e) => setIsSendMsg({ data: e, status: false })}
                // checkboxSelection={loggedInUser?.role?.name === Role.EPMO_OFFICER}
                localeText={{
                  MuiTablePagination: {
                    labelRowsPerPage: t("Actions per page:"), // Or your desired custom text
                  },
                }}
              />
            </div>
          )} */}

            {isOpenApprovalDrawer && (
              <ApprovalUserHistory
                isOpen={isOpenApprovalDrawer}
                handleClose={handleCloseDrawer}
                approvalLog={selectedApproval}
                refresh={deliverableRefresh}
                module={moduleName}
                moduleDetail={moduleDetail}
              />
            )}
            {actionType === 'Projectdeliverable' ?
              <SubmitOtherDeliverableComment
                handleRejectModal={handleCloseModal}
                selectedRow={selectedDeliverable}
                open={openModal}
                comment={comment}
                handleApproval={handletrigger}
                module={moduleName}
                handleClose={handleCloseDeliverableDrawer}
              /> :
              <CommentModal
                handleRejectModal={handleCloseModal}
                open={openModal}
                handleApproval={handletrigger}
                module={moduleName}
              />}
            {/* {aprrovalList.length === 0 && isLoading && <Loader />}
          {aprrovalList.length === 0 && !isLoading && (
            <NodataFound
              text={props.t("No actions to show")}
              icon={userImage}
            />
          )} */}
            {drawerOpen && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 1 && deliverableAction === Action.VIEW && (
              <SubmitLegalDocument
                isOpen={drawerOpen}
                handleClose={handleCloseDeliverableDrawer}
                selectedRow={selectedDeliverable}
                refresh={deliverableRefresh}
                isDisabled={true}
                action={deliverableAction}
                source={"ActionList"}
              />
            )}

            {drawerOpen && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 1
              && deliverableAction === Action.SUBMIT && (
                <SubmitLegalDocumentComment
                  isOpen={drawerOpen}
                  handleClose={handleCloseDeliverableDrawer}
                  selectedRow={selectedDeliverable}
                  refresh={deliverableRefresh}
                  isDisabled={true}
                  action={deliverableAction}
                  source={"ActionList"}
                  submit={() => {
                    handleReject(
                      selectedDeliverable.moduleId,
                      selectedDeliverable.actionType,
                      selectedDeliverable.approvalUsers[0].project.id,
                      selectedDeliverable.id
                    )
                  }}
                />
              )}

            {drawerOpen && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 1
              && deliverableAction === Action.APPROVE && (
                <SubmitLegalDocument
                  isOpen={drawerOpen}
                  handleClose={handleCloseDeliverableDrawer}
                  selectedRow={selectedDeliverable}
                  refresh={deliverableRefresh}
                  isDisabled={true}
                  action={deliverableAction}
                  source={"ActionList"}
                  handleStatusChange={handleStatusChange}
                  rowId={rowId}
                  actionType={actionType}
                  projectIdForApproval={projectIdForApproval}
                  moduleIdforApproval={moduleIdforApproval}
                />
              )}

          {drawerOpen  && deliverbleStatus && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 1 
            && deliverableAction === Action.APPROVE_REJECT_SHOW && (
            <SubmitLegalDocument
            isOpen={drawerOpen}
            handleClose={handleCloseDeliverableDrawer}
            selectedRow={selectedDeliverable}
            refresh={deliverableRefresh}
            isDisabled={true}
            action={deliverableAction}
            source={"ActionList"}
            handleStatusChange={handleStatusChange}
            rowId={rowId}
            status={deliverbleStatus}
            actionType={actionType}
            projectIdForApproval={projectIdForApproval}
            moduleIdforApproval={moduleIdforApproval}
            fetchDeliverableDetails={fetchDeliverableDetails}
            />
          )}

            {drawerOpen && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 2
              && deliverableAction === Action.SUBMIT && (
                <SubmitSecondDeliverableComment
                  isOpen={drawerOpen}
                  handleClose={handleCloseDeliverableDrawer}
                  selectedRow={selectedDeliverable}
                  refresh={deliverableRefresh}
                  isDisabled={true}
                  action={deliverableAction}
                  source={"ActionList"}
                />
              )}

            {drawerOpen && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 2
              && deliverableAction === Action.VIEW && (
                <SubmitSecondDeliverable
                  isOpen={drawerOpen}
                  handleClose={handleCloseDeliverableDrawer}
                  selectedRow={selectedDeliverable}
                  refresh={deliverableRefresh}
                  isDisabled={true}
                  action={deliverableAction}
                  source={"ActionList"}
                />
              )}

            {drawerOpen && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 2
              && deliverableAction === Action.APPROVE && (
                <SubmitSecondDeliverable
                  isOpen={drawerOpen}
                  handleClose={handleCloseDeliverableDrawer}
                  selectedRow={selectedDeliverable}
                  refresh={deliverableRefresh}
                  isDisabled={true}
                  action={deliverableAction}
                  source={"ActionList"}
                  handleStatusChange={handleStatusChange}
                  rowId={rowId}
                  actionType={actionType}
                  projectIdForApproval={projectIdForApproval}
                  moduleIdforApproval={moduleIdforApproval}
                />
              )}

          {drawerOpen && deliverbleStatus && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder === 2 
            && deliverableAction === Action.APPROVE_REJECT_SHOW && (
            <SubmitSecondDeliverable
            isOpen={drawerOpen}
            handleClose={handleCloseDeliverableDrawer}
            selectedRow={selectedDeliverable}
            refresh={deliverableRefresh}
            isDisabled={true}
            action={deliverableAction}
            source={"ActionList"}
            handleStatusChange={handleStatusChange}
            rowId={rowId}
            status={deliverbleStatus}
            actionType={actionType}
            projectIdForApproval={projectIdForApproval}
            moduleIdforApproval={moduleIdforApproval}
            fetchDeliverableDetails={fetchDeliverableDetails}
            />
          )}


            {drawerOpen && selectedDeliverable && selectedDeliverable.deliverable.deliverableOrder > 2
              && deliverableAction === Action.VIEW && (
                <SubmitDeliverable
                  isOpen={drawerOpen}
                  handleClose={handleCloseDeliverableDrawer}
                  selectedRow={selectedDeliverable}
                  refresh={deliverableRefresh}
                  isDisabled={true}
                  action={deliverableAction}
                  source={"ActionList"}
                  handleApproval={handletrigger}
                />
              )}

            {drawerOpen && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder > 2
              && deliverableAction === Action.APPROVE && (
                <SubmitDeliverable
                  isOpen={drawerOpen}
                  handleClose={handleCloseDeliverableDrawer}
                  selectedRow={selectedDeliverable}
                  refresh={deliverableRefresh}
                  isDisabled={true}
                  action={deliverableAction}
                  source={"ActionList"}
                  handleStatusChange={handleStatusChange}
                  rowId={rowId}
                  actionType={actionType}
                  projectIdForApproval={projectIdForApproval}
                  moduleIdforApproval={moduleIdforApproval}
                  handleApproval={handletrigger}
                />
              )}

          {drawerOpen && deliverbleStatus && selectedDeliverable && selectedDeliverable?.deliverable?.deliverableOrder > 2 
            && deliverableAction === Action.APPROVE_REJECT_SHOW && (
            <SubmitDeliverable
            isOpen={drawerOpen}
            handleClose={handleCloseDeliverableDrawer}
            selectedRow={selectedDeliverable}
            refresh={deliverableRefresh}
            isDisabled={true}
            action={deliverableAction}
            source={"ActionList"}
            handleStatusChange={handleStatusChange}
            status={deliverbleStatus}
            rowId={rowId}
            actionType={actionType}
            handleApproval={handletrigger}
            projectIdForApproval={projectIdForApproval}
            moduleIdforApproval={moduleIdforApproval}
            fetchDeliverableDetails={fetchDeliverableDetails}
            />
          )}
        </div>
      </Container>
    </div>
  );
};
export default withTranslation()(ActionList);
